import { appModule } from "@/store/modules/app";
import { pesanGagalJaringan } from "@/utils/gagalJaringan";

function flattenErrors(errors: any): string {
  if (errors == null) return "";
  if (typeof errors === "string") return errors;
  if (Array.isArray(errors)) {
    return errors
      .map(v => (Array.isArray(v) ? v.join("; ") : String(v)))
      .join("; ");
  }
  if (typeof errors === "object") {
    return Object.values(errors)
      .map(v => (Array.isArray(v) ? v.join("; ") : String(v)))
      .join("; ");
  }
  return String(errors);
}

class ErrorAlert {
  msgTtd = "";
  showSnackAlert(e, pesan) {
    let dt = e?.response;
    let message = "";
    if (!dt) {
      appModule.NoticeDelayAlert("Gagal Ambil Data " + pesan);
      return;
    }
    if (dt["status"] == 422) {
      message = flattenErrors(e.response.data.errors);
      dt = {
        status: 0,
        err:
          "Gagal Ambil Data " +
          pesan +
          " ERROR 422 : " +
          e.response.data.message +
          " (" +
          message +
          ")"
      };
    } else {
      dt = {
        data: dt,
        status: dt["status"],
        err:
          "Gagal Ambil Data " +
          pesan +
          " ERROR " +
          e.response.status +
          " : " +
          e.response.data.message
      };
    }
    appModule.NoticeDelayAlert(dt.err);
  }

  showErrorAlert(e) {
    appModule.setLoading(false);
    let dt = e?.response;
    let message = "";

    if (!dt) {
      appModule.sendErrorAlert(
        e?.isAxiosError
          ? pesanGagalJaringan(e.config?.method)
          : typeof e === "string"
          ? e
          : e?.message || "Terjadi kesalahan"
      );
      return;
    }

    if (dt["status"] == 422) {
      message = flattenErrors(e.response.data.errors);
      dt = {
        status: 0,
        err: "ERROR 422 : " + e.response.data.message + " (" + message + ")"
      };
    } else {
      dt = {
        data: dt,
        status: dt["status"],
        err: "ERROR " + e.response.status + " : " + e.response.data.message
      };
    }
    appModule.sendErrorAlert(dt.err);
  }
}

export default new ErrorAlert();
//
